// extracted by mini-css-extract-plugin
module.exports = {"button":"ConfigPanel_button__vMcos"};